import { PagBankPublicKey } from '.'

export const EncryptCard = async (formContext, setAlerts) => {
  // ====> DEV
  // const PUBLIC_KEY =
  //   'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAr+ZqgD892U9/HXsa7XqBZUayPquAfh9xx4iwUbTSUAvTlmiXFQNTp0Bvt/5vK2FhMj39qSv1zi2OuBjvW38q1E374nzx6NNBL5JosV0+SDINTlCG0cmigHuBOyWzYmjgca+mtQu4WczCaApNaSuVqgb8u7Bd9GCOL4YJotvV5+81frlSwQXralhwRzGhj/A57CGPgGKiuPT+AOGmykIGEZsSD9RKkyoKIoc0OS8CPIzdBOtTQCIwrLn2FxI83Clcg55W8gkFSOS6rWNbG5qFZWMll6yl02HtunalHmUlRUL66YeGXdMDC2PuRcmZbGO5a/2tbVppW6mfSWG3NPRpgwIDAQAB'

  const PUBLIC_KEY = await PagBankPublicKey().get()
  console.log(PUBLIC_KEY)

  // eslint-disable-next-line no-undef
  const card = PagSeguro.encryptCard({
    publicKey: PUBLIC_KEY,
    // publicKey: 'chave_publica',
    holder: formContext?.nome_cartao,
    number: formContext?.numero_cartao,
    expMonth: formContext?.validade_cartao.split('/')[0],
    expYear: formContext?.validade_cartao.split('/')[1],
    securityCode: formContext?.cvc,
  })

  const hasError = card.hasErrors
  const error = card?.errors?.[0]?.code ?? null

  if (hasError) {
    if (error === 'INVALID_NUMBER') {
      setAlerts((prev) => [
        ...prev,
        {
          title: 'Número do Cartão',
          msg: 'O número do cartão inserido está incorreto.',
          type: 'error',
        },
      ])
    } else if (error === 'INVALID_SECURITY_CODE') {
      setAlerts((prev) => [
        ...prev,
        {
          title: 'Código do Cartão',
          msg: 'O código do cartão inserido está incorreto.',
          type: 'error',
        },
      ])
    } else if (error === 'INVALID_EXPIRATION_MONTH') {
      setAlerts((prev) => [
        ...prev,
        {
          title: 'Mês Inválido',
          msg: 'A data de mês inserida está incorreta. Deve ser um número de 1 a 12.',
          type: 'error',
        },
      ])
    } else if (error === 'INVALID_EXPIRATION_YEAR') {
      setAlerts((prev) => [
        ...prev,
        {
          title: 'Ano Inválido',
          msg: 'A data do ano inserida está incorreta. Preencha com 4 dígitos. Ex: 2025',
          type: 'error',
        },
      ])
    } else if (error === 'INVALID_HOLDER') {
      setAlerts((prev) => [
        ...prev,
        {
          title: 'Nome do Cartão',
          msg: 'Houve algum problema no nome inserido.',
          type: 'error',
        },
      ])
    }
    return null
  }

  return card.encryptedCard
}
